export enum ActionEnum {
  UpdateStatus = 0,
  UpdatePriority = 1,
  UpdateType = 2,
  UpdateDifficulty = 3,
  CreateTask = 4,
  AttachTag = 5,
  AttachFile = 6,
  AddPerformer = 7,
  AddObserver = 8,
  AttachSubtask = 9,
  UpdateDateEnd = 10,
  UpdateName = 11,
  RemoveSubtask = 12,
  RemoveFile = 13,
  RemovePerformer = 14,
  RemoveObserver = 15,
  RemoveTag = 16,
}
